import { render } from "./editor.vue?vue&type=template&id=6ec62ac5&scoped=true"
import script from "./editor.vue?vue&type=script&lang=js"
export * from "./editor.vue?vue&type=script&lang=js"

import "./editor.vue?vue&type=style&index=0&id=6ec62ac5&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-6ec62ac5"

export default script